import { omit, concat, findIndex } from 'lodash'
import { http, queryString } from 'utils'

// Load mutation imports.
import { SET_LOADS, SET_LOADS_PAGINATION, ADD_LOADS, RESET_LOADS, ADD_LOAD, REMOVE_LOAD } from 'vx/mutations'

// Load state.
const state = {
  loads: []
}

// Load state getters.
const getters = {
  /**
   * Determine if we have any loads.
   */
  haveLoadChecks: state => state.loads.length > 0,

  /**
   * Determine if we have no loads.
   */
  haveNoLoadChecks: state => state.loads.length === 0
}

// Load actions.
const actions = {
  /**
   * Get all loads.
   */
  getLoadChecks ({ commit }, payload) {
    commit(RESET_LOADS)

    return http.get(`load-checks?${queryString(payload)}`).then(response => {
      commit(SET_LOADS, response.data.data)
      commit(SET_LOADS_PAGINATION, omit(response.data, 'data'))

      return response
    })
  },

  /**
   * Get the loads for the next page.
   */
  getLoadChecksForNextPage ({ commit, state }, payload) {
    if (state.pagination.current_page === state.pagination.last_page || state.pagination.total === 0) {
      return Promise.reject('There are no more loads to load.')
    }

    let page = state.pagination.current_page + 1

    return http.get(`load-checks?${queryString(payload)}&page=${page}`).then(response => {
      commit(ADD_LOADS, response.data.data)
      commit(SET_LOADS_PAGINATION, omit(response.data, 'data'))

      return response
    })
  }
}

// Load state mutations.
const mutations = {
  /**
  * Set the loads.
  */
  [SET_LOADS] (state, loads) {
    state.loads = loads
  },

  /**
   * Add more loads to the loads state.
   */
  [ADD_LOADS] (state, loads) {
    state.loads = concat(state.loads, loads)
  },

  /**
   * Set the load pagination.
   */
  [SET_LOADS_PAGINATION] (state, pagination) {
    state.pagination = pagination
  },

  /**
   * Reset the loads.
   */
  [RESET_LOADS] (state) {
    state.loads = []
  },

  /**
   * Add a load or replace an existing.
   */
  [ADD_LOAD] (state, load) {
    let existingLoad = findIndex(state.loads, existing => existing.id === load.id)

    if (existingLoad === -1) {
      state.loads.push(load)
    } else {
      state.loads.splice(existingLoad, 1, load)
    }
  },

  /**
   * Remove a load.
   */
  [REMOVE_LOAD] (state, load) {
    let existingIndex = findIndex(state.loads, existing => existing.id === load.id)

    if (existingIndex > -1) {
      state.loads.splice(existingIndex, 1)
    }
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/load-check.js